$bog_bzrl_app_rent $mol_view
	district? \all
	rooms? \studio
	price_from? \
	search? null
	apartments /
	apartment_district* \
	apartment_photo* \
	apartment_area* \
	apartment_floor* \
	apartment_price* \
	promo_action? null
	sub /
		<= Title_section $mol_paragraph
			title @ \Rent in Kazan directly from owners
		<= Filter $bog_bzrl_app_filter
			district? <=> district? \all
			rooms? <=> rooms? \studio
			price_from? <=> price_from? \
			search? <=> search? null
		<= Apartments $mol_view
			attr *
				id \apartments
			sub <= apartment_rows /$mol_view
				<= Apartment* $bog_bzrl_app_card
					district <= apartment_district* \
					photo <= apartment_photo* \
					area <= apartment_area* \
					floor <= apartment_floor* \
					price <= apartment_price* \
		<= Promo $bog_bzrl_app_hero_promo
			action? <=> promo_action? null
		<= How_it_works $mol_view
			attr *
				id \how
			sub /
				<= How_title $mol_paragraph
					title @ \how it works
				<= Steps $mol_view
					sub /
						<= Step_match $bog_bzrl_app_step_match
						<= Step_request $bog_bzrl_app_step_request
						<= Step_pay $bog_bzrl_app_step_pay
		<= Privacy $mol_view
			attr *
				id \privacy
			sub /
				<= Privacy_slider $bog_bzrl_app_slider
				<= Privacy_content $bog_bzrl_app_hero_privacy
		<= Benefits $mol_view
			attr *
				id \benefits
			sub /
				<= Benefits_title $mol_paragraph
					title @ \benefits
				<= Benefits_list $mol_view
					sub /
						<= Benefit_owners $bog_bzrl_app_benefit_owners
						<= Benefit_verified $bog_bzrl_app_benefit_verified
						<= Benefit_secure $bog_bzrl_app_benefit_secure
		<= Team $bog_bzrl_app_hero_team
			attr *
				id \team
			photo \bog/bzrl/assets/HomeRent-Design-System-Frame-77.png
		<= Footer $bog_bzrl_app_footer
			attr *
				id \contact
